import React, { useEffect, useState } from "react";
import {
  BootstrapTable,
  TableHeaderColumn,
  ClearSearchButton,
} from "react-bootstrap-table";
import { formatMoney, formatMontant } from "../../../utils/utils";
import { getDataByID } from "../../utils/fetchData";
import TopTableSkeleton from "./TopTableSkeleton";

const TopEntreprise = (props) => {
  const [topEntreprises, setTopEntreprises] = useState([]);
  var [isPageLoading, setIsPageLoading] = useState(true);
  useEffect(() => {
    if (
      props?.auth?.user?.id &&
      (props?.auth?.user?.user_type === "ipm" ||
        props?.auth?.user?.user_type === "assurance_sante" ||
        props?.auth?.user?.user_type === "admin_ipm")
    ) {
      if (!props?.auth?.user?.admin_type) {
        getDataByID(
          `top10montantbyipm`,
          props?.auth?.user?.id,
          props?.auth?.token
        ).then((response) => {
          // console.log("response", response);
          setTopEntreprises(response?.top10MontantEntreprise);
          setIsPageLoading(false);
        });
      } else {
        getDataByID(
          `top10montantbyipm`,
          props?.auth?.user?.id,
          props?.auth?.token
        ).then((response) => {
          setTopEntreprises(response?.top10MontantEntreprise);
          setIsPageLoading(false);
        });
      }
    }
  }, [props?.auth]);

  const entFormat = (cell, row) => {
    return row?.item?.raison_sociale;
  };

  const entIDFormat = (cell, row) => {
    return row?.item?.id;
  };

  const montantFormat = (cell, row) => {
    return formatMontant(cell);
  };

  const options = {
    sizePerPage: 5,
    clearSearch: true,
    noDataText: "Aucune donnée disponible",
    expandBy: "column",
  };

  return (
    <div className="chart-item-container">
      <div className="row mb-2">
        <div className="col-xl-12 col-lg-12">
          <h2 className="chart-item-title">
            Top 10 des montants facturés aux adhérents{" "}
          </h2>
        </div>
      </div>
      <div className="table-responsive">
        {isPageLoading && <TopTableSkeleton />}
        {!isPageLoading && (
          <BootstrapTable
            data={topEntreprises}
            striped={true}
            hover={true}
            condensed={true}
            multiColumnSort={2}
            options={options}
            pagination
            search={false}
            version="4"
            bordered={false}
          >
            <TableHeaderColumn
              thStyle={{
                fontWeight: 600,
                fontSize: 16,
                color: "#1F497D",
              }}
              tdStyle={{
                fontWeight: 500,
                fontSize: 14,
                color: "rgba(0, 0, 0, 0.7)",
              }}
              dataField="item"
              isKey={true}
              hidden={false}
              expandable={false}
              width="50"
              dataFormat={entIDFormat}
            >
              N°
            </TableHeaderColumn>
            <TableHeaderColumn
              thStyle={{
                fontWeight: 600,
                fontSize: 16,
                color: "#1F497D",
              }}
              tdStyle={{
                fontWeight: 500,
                fontSize: 14,
                color: "rgba(0, 0, 0, 0.7)",
              }}
              dataFormat={entFormat}
              dataField="entreprise"
            >
              Adhérent
            </TableHeaderColumn>
            <TableHeaderColumn
              thStyle={{
                fontWeight: 600,
                fontSize: 16,
                color: "#1F497D",
              }}
              tdStyle={{
                fontWeight: 500,
                fontSize: 14,
                color: "rgba(0, 0, 0, 0.7)",
              }}
              width="200"
              dataAlign="right"
              dataFormat={montantFormat}
              dataField="montant"
            >
              Montant (F CFA)
            </TableHeaderColumn>
            {/* <TableHeaderColumn
              thStyle={{
                fontWeight: 600,
                fontSize: 16,
                color: "#1F497D",
              }}
              tdStyle={{
                fontWeight: 500,
                fontSize: 14,
                color: "rgba(0, 0, 0, 0.7)",
              }}
              dataFormat={entFormat}
              dataField="montant_entreprise"
            >
              Entreprises
            </TableHeaderColumn> */}
          </BootstrapTable>
        )}
      </div>
    </div>
  );
};

export default TopEntreprise;
